import ImageCard from 'components/cards/base/ImageCard'
import Strings from 'project/localisation'
import { ReactFC } from 'common/types/ReactFC'
import React from 'react'
import { planPerksStrings } from 'common/strings/plan-perks-strings' // we need this to make JSX compile
import { getMailCountRounded } from 'common/utils/getMailCountString'
import { Tenant } from 'common/tenant'
import { Constants, getFullAddress } from 'common/utils/constants'

type PlanPerksCardType = {
  tenant?: Tenant
}

function perks(tenant: Tenant) {
  return [
    {
      description:
        tenant === Tenant.AU
          ? `Use ${Constants.companyInformation.address2Au}, ${Constants.companyInformation.cityAu} ${Constants.companyInformation.postal_codeAu} as your company’s official registered office address with ASIC and everyone related to your business.`
          : `Use ${getFullAddress(
              Tenant.UK,
            )} as your company’s official registered office address with Companies House.`,
      title:
        tenant === Tenant.AU
          ? 'A low-cost virtual Sydney Address.'
          : 'A low-cost virtual London address.',
    },
    {
      description:
        'We scan and send your mail to your inbox, the mobile app, and customer portal within one business day.',
      title: 'Mail services straight to your inbox within 1 day.',
    },
    {
      description:
        'HaiRo™ provides you with mail summaries, category tags, and key details from your correspondence.  Once we receive a new mail item, HaiRo™ notifies you and your team, so you never miss important business mail.',
      title: 'AI-powered mail handling services to streamline your business.',
    },
    {
      description:
        'Our state-of-the-art technology digitises and organises your physical mail, making every mail item fully searchable. Mail management made easy.',
      title: 'Digitised and organised.',
    },
    {
      description: `Never lose a document again — over ${getMailCountRounded()} pieces of mail processed to date. 100,000+ customers to date and growing.`,
      title: 'Always safe and secure.',
    },
    {
      description:
        'Simple price plan for your virtual office address and mail services provided by HaiRo™.',
      title: 'One plan, 10-minute setup, monthly cancellation.',
    },
    {
      description:
        'We automatically filter out junk mail, ensuring you only receive the important communications that matter to your business. Spend less time sorting and more time focusing on what’s essential.',
      title: 'Built-in Junk Mail Filter.',
    },
  ]
}
const PlanPerksCard: ReactFC<PlanPerksCardType> = ({ tenant = Tenant.UK }) => {
  return (
    <ImageCard
      shadow={false}
      reverseColumnsMobile
      verticalAlign='center'
      padding='0'
      imageAlt='HaiRo™ robot holding a phone'
      imageLeft
      image='/images/new/cool-robot-holding-phone.png'
      imageDimensions={{
        height: 831,
        width: 563,
      }}
      classNameForCol1='col-lg-12 col-xxl-6 pe-xxl-14 px-6'
      classNameForCol2='col-lg-6 offset-xxl-0 offset-lg-3 col-xl-6 ps-xxl-18'
    >
      <p className='fw-semibold fs-fluid-24-32 mb-4'>
        {Strings.signupIncludes}
      </p>
      {perks(tenant).map((v) => (
        <>
          <p className='text-large fw-bold mb-2'>{v.title}</p>
          <p
            className='text-large fw-semibold mb-6 text-muted'
            dangerouslySetInnerHTML={{ __html: v.description }}
          />
        </>
      ))}
    </ImageCard>
  )
}

export default PlanPerksCard
